// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\n.form-actions {\n  width: 100%;\n}\n", "",{"version":3,"sources":["form-actions.css"],"names":[],"mappings":";AAAA;EACE,WAAA;AAEF","file":"form-actions.css","sourcesContent":[".form-actions {\n  width: 100%;\n}\n"]}]);
// Exports
module.exports = exports;
